import React from "react";
import styled from "styled-components";
import LinkButton from "@common/LifeAtButton/Variants/LinkButton";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import { showMainWindow } from "@desktop/ToDesktopService";
import useSessionStorage, { SessionStorageKeys } from "@hooks/useSessionStorage";
import { FontSize } from "@themes/Fonts";

const LandingWrapper = styled.div`
    height: 100vh;
    width: 100vw;
`;

const Container = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    background: ${(props) => props.theme.backgroundPrimary};
`;

const Label = styled.div`
    color: ${(props) => props.theme.textColorPrimary};
    font-size: ${FontSize.large};
`;

const StyledLinkButton = styled(LinkButton)`
    color: ${(props) => props.theme.textColorPrimary};
`;

const CANNOT_LOAD_LABEL = "LifeAt cannot connect";
const RELOAD_BUTTON_LABEL = "Reload LifeAt";
const SIGNIN_BUTTON_LABEL = "Sign in to your account";
const RELOAD_LINK_BUTTON_LABEL = "Already signed in? Click to reload";

function DesktopAppMenubarLanding() {
    const [hasSeenReloadScreen, setHasSeenReloadScreen] = useSessionStorage(
        SessionStorageKeys.HasSeenReloadScreen,
        false,
    );

    const handleReloadClick = () => {
        setHasSeenReloadScreen(true);
        window.location.reload();
    };

    const reloadPageContent = (
        <>
            <Label>{CANNOT_LOAD_LABEL}</Label>
            <SpecialLifeAtButton
                isLink={false}
                text={RELOAD_BUTTON_LABEL}
                handleClick={handleReloadClick}
                variant={"blue"}
            />
        </>
    );

    const signInContent = (
        <>
            <SpecialLifeAtButton
                isLink={false}
                text={SIGNIN_BUTTON_LABEL}
                handleClick={() => showMainWindow()}
                variant={"blue"}
            />
            <StyledLinkButton label={RELOAD_LINK_BUTTON_LABEL} handleClick={handleReloadClick} />
        </>
    );

    return (
        <LandingWrapper className={`menubar-landing-wrapper`}>
            <Container>{hasSeenReloadScreen ? signInContent : reloadPageContent}</Container>
        </LandingWrapper>
    );
}
export default DesktopAppMenubarLanding;
